module.exports = __webpack_public_path__ + "static/media/filterSvg.7573c294.svg";